export default __webpack_public_path__ + "static/media/Fantom of the Opera.cddeecb9.png";